import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LANGS = [
  { code: "es", label: "ES", name: "Español", flag: "🇨🇱" },
  { code: "pt", label: "PT", name: "Português", flag: "🇧🇷" },
  { code: "en", label: "EN", name: "English", flag: "🇺🇸" },
];

/**
 * LanguageSwitcher — dropdown compacto para cambiar idioma de la UI.
 * Persiste la elección en localStorage.kiltro_lang (via i18next-browser-languagedetector).
 */
export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const current = LANGS.find((l) => l.code === i18n.language.slice(0, 2)) || LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-mono uppercase tracking-widest text-[#FEBA01] border border-[#333] hover:border-[#FEBA01] transition-colors"
        data-testid="lang-switcher-trigger"
        aria-label="Cambiar idioma"
      >
        <Globe size={12} /> {current.label}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 z-40 min-w-[140px] bg-[#0A0A0A] border-2 border-[#FEBA01] shadow-brutal">
            {LANGS.map((l) => (
              <button
                key={l.code}
                onClick={() => change(l.code)}
                className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-[#FEBA01] hover:text-black transition-colors ${
                  l.code === current.code ? "text-[#FEBA01]" : "text-[#F5F5F5]"
                }`}
                data-testid={`lang-option-${l.code}`}
              >
                <span>{l.flag}</span>
                <span>{l.name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
